import { MessageSquare, Clock, Zap } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import type { AgentTrigger } from '@/lib/mock-agents-data';
import type { LucideIcon } from 'lucide-react';

const TRIGGER_CONFIG: Record<AgentTrigger, { label: string; icon: LucideIcon; color: string }> = {
  conversational: { label: 'Chat', icon: MessageSquare, color: 'bg-blue-500/10 text-blue-600 dark:text-blue-400' },
  scheduled: { label: 'Scheduled', icon: Clock, color: 'bg-amber-500/10 text-amber-600 dark:text-amber-400' },
  event: { label: 'Event', icon: Zap, color: 'bg-violet-500/10 text-violet-600 dark:text-violet-400' },
};

export function TriggerBadges({ triggers, className }: { triggers: AgentTrigger[]; className?: string }) {
  return (
    <div className={cn('flex items-center gap-1', className)}>
      {triggers.map(t => {
        const config = TRIGGER_CONFIG[t];
        const Icon = config.icon;
        return (
          <Badge key={t} variant="outline" className={cn('text-[9px] gap-0.5', config.color)}>
            <Icon className="h-2.5 w-2.5" /> {config.label}
          </Badge>
        );
      })}
    </div>
  );
}
